var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4CeeExchangeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 523.7 187.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #ee506f;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 233,
    y1: 78.73,
    x2: 224.76,
    y2: 111.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f38363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f28163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#f27a65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#f06e67"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#ef5d6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee506f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 60.17,
    y1: 75.5,
    x2: 60.17,
    y2: 119.3,
    gradientTransform: "translate(17.21 -9.02) rotate(9.99)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f38363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee506f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 446.05,
    y1: 93.9,
    x2: 87.03,
    y2: 93.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#629afd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#6398fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#6991fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#7385fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#8274fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8770ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M307.75,85.62h-31.36l-2.96-12.67,33.58-39.96h18.13v39.22h8.23v13.41h-8.23v12.58h-17.39v-12.58ZM307.75,72.3v-18.59l-15.45,18.59h15.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M339.48,66.01v-.19c0-18.87,14.52-33.67,34.13-33.67,13.23,0,21.74,5.55,27.47,13.5l-13.5,10.45c-3.7-4.62-7.96-7.58-14.15-7.58-9.07,0-15.45,7.68-15.45,17.11v.19c0,9.71,6.38,17.3,15.45,17.3,6.75,0,10.73-3.15,14.61-7.86l13.5,9.62c-6.1,8.42-14.34,14.61-28.67,14.61-18.5,0-33.39-14.15-33.39-33.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M409.23,33.45h52.08v15.26h-34.32v9.8h31.08v14.15h-31.08v10.27h34.78v15.26h-52.54V33.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.92,33.45h52.08v15.26h-34.32v9.8h31.08v14.15h-31.08v10.27h34.78v15.26h-52.54V33.45Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 168.36,
    cy: 93.91,
    r: 32.35
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 11.96,
    cy: 93.91,
    r: 11.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 229.21,
    cy: 93.91,
    r: 13.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60.17,
    cy: 93.91,
    r: 22.39,
    transform: "translate(-15.38 11.86) rotate(-9.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M222.24,137.44c-2.92-1.3-6.52-1.95-10.71-1.95-5.35,0-10.2,1.45-14.42,4.33-4.47,3.01-9.37,5.44-14.54,7.24-5.23,1.8-10.87,2.71-16.78,2.71-7.63,0-14.95-1.47-21.76-4.37-6.79-2.89-12.85-6.92-18-11.97-5.15-5.05-9.29-11.03-12.31-17.77-3.04-6.78-4.58-14.09-4.58-21.74s1.54-14.97,4.58-21.74c3.02-6.74,7.16-12.7,12.32-17.72,5.14-5.01,11.19-9.03,17.97-11.96,3.46-1.5,7.06-2.63,10.72-3.36l1.05-.2c3.27-.59,6.63-.88,10.01-.88,5.83,0,11.42.89,16.63,2.64,5.13,1.73,10.08,4.19,14.71,7.32,4.3,2.95,9.14,4.45,14.4,4.45,3.92,0,7.48-.7,10.57-2.09,3.13-1.41,5.94-3.34,8.34-5.74l9.45-9.45c-4.84-4.96-9.99-9.54-15.33-13.63-5.96-4.55-12.22-8.46-18.62-11.63-6.33-3.15-12.98-5.62-19.77-7.34-6.72-1.7-13.58-2.57-20.38-2.57-8.64,0-17.08,1.12-25.09,3.34-8.02,2.22-15.64,5.4-22.66,9.46-7.02,4.06-13.47,9-19.17,14.68-5.71,5.64-10.68,12.02-14.79,18.97-3.67,6.21-6.64,12.9-8.84,19.93,9.72,5.34,16.33,15.68,16.33,27.54s-6.6,22.19-16.32,27.54c2.2,7.02,5.16,13.71,8.83,19.92,4.1,6.93,9.08,13.32,14.79,18.98,5.71,5.67,12.16,10.61,19.17,14.66,7.01,4.07,14.63,7.25,22.65,9.46,8.01,2.22,16.45,3.34,25.09,3.34,6.8,0,13.66-.86,20.38-2.57,6.74-1.71,13.4-4.18,19.78-7.34,6.39-3.17,12.65-7.08,18.61-11.63,5.35-4.09,10.5-8.67,15.33-13.63l-9.45-9.45c-2.48-2.48-5.25-4.42-8.21-5.75Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M272.25,123.14h24.61v7.21h-16.21v4.63h14.68v6.69h-14.68v4.85h16.43v7.21h-24.82v-30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M309.66,138.17l-10.05-15.03h9.74l5.42,8.61,5.46-8.61h9.53l-10.05,14.95,10.49,15.64h-9.75l-5.86-9.22-5.9,9.22h-9.53l10.49-15.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M330.02,138.52v-.09c0-8.92,6.86-15.91,16.13-15.91,6.25,0,10.27,2.62,12.98,6.38l-6.38,4.94c-1.75-2.19-3.76-3.58-6.69-3.58-4.28,0-7.3,3.63-7.3,8.08v.09c0,4.59,3.02,8.17,7.3,8.17,3.19,0,5.07-1.49,6.9-3.71l6.38,4.54c-2.88,3.98-6.77,6.9-13.55,6.9-8.74,0-15.78-6.69-15.78-15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M362.97,123.14h8.48v11.45h10.88v-11.45h8.48v30.59h-8.48v-11.62h-10.88v11.62h-8.48v-30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M406.8,122.92h8.17l13.02,30.81h-9.09l-2.23-5.46h-11.8l-2.19,5.46h-8.91l13.02-30.81ZM414.23,141.67l-3.41-8.7-3.45,8.7h6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M430.96,123.14h7.91l12.59,16.17v-16.17h8.39v30.59h-7.43l-13.07-16.78v16.78h-8.39v-30.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M464.22,138.52v-.09c0-8.92,6.99-15.91,16.47-15.91,5.38,0,9.18,1.66,12.41,4.46l-4.98,5.99c-2.19-1.84-4.37-2.88-7.38-2.88-4.41,0-7.82,3.71-7.82,8.39v.09c0,4.94,3.45,8.48,8.3,8.48,2.05,0,3.63-.44,4.89-1.27v-3.71h-6.03v-6.21h14.07v13.77c-3.23,2.67-7.74,4.72-13.29,4.72-9.53,0-16.65-6.55-16.65-15.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M498.87,123.14h24.6v7.21h-16.21v4.63h14.68v6.69h-14.68v4.85h16.43v7.21h-24.82v-30.59Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4CeeExchangeLogo);
export default __webpack_public_path__ + "static/media/4CEE_Exchange_logo.4aa99c4ec01a8f081ae58f97ba02c10c.svg";
export { ForwardRef as ReactComponent };